'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.url = exports.API_URL = undefined;

var _env = require('../env/env');

var API_URL = exports.API_URL = {
  production: 'https://george-api-production.drivesally.com/api',
  development: 'https://george-api-staging.drivesally.com/api',
  demo: 'https://george-api-demo.drivesally.com/api'
};

var url = exports.url = function url() {
  return (0, _env.getEnvData)('API_URL');
};